import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { HEADERS } from 'src/app/constants/services-headers';

import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class RisksService {

  constructor(private http: HttpClient) { }

  /* request(): Método común que solicita información al api de indicadores de red de acuerdo a los parámetros recibidos
    data: Parámetros recibidos desde cada componente
    nameMethod: Método que se ejecutará en el controlador del api
  */
  request = (data: FormData, nameMethod: string): Observable<any> => this.http.post(environment.apiPath + "ApiRisks/" + nameMethod, data, HEADERS);

  // getIRLInfo(): Servicio para obtener información de IRL
  getIRLInfo = (data: FormData, nameMethod: string): Observable<any> => this.request(data, nameMethod);

}
